import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { CompanyDetailsMini } from 'appRootPath/models/commercial-papers.model';
import { CpMarketplaceApiService } from 'appRootPath/services/cp-marketplace-api.service';
import { UserData } from 'appRootPath/shared/global-meta-data';

@Component({
  selector: 'app-company-selection',
  templateUrl: './company-selection.component.html',
  styleUrls: ['./company-selection.component.scss']
})
export class CompanySelectionComponent implements OnInit {
  @Input() companiesList: CompanyDetailsMini[];
  @Output() companySelectionEvent = new EventEmitter<UserData>(null);
  @Output() errorEvent = new EventEmitter(null);

  constructor(
    private apiService: CpMarketplaceApiService
  ) { }

  ngOnInit() {
  }

  handleCompanySelection(company: CompanyDetailsMini) {
    this.apiService.loginWithCompany(company.company_id).subscribe((loginResp: UserData) => {
      if (loginResp.token) {
        this.companySelectionEvent.emit(loginResp);
      }
    }, error => {
      this.errorEvent.emit(error);
    });
  }
}
